import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {AisCommonModule, AuthInterceptorService} from 'ais-common';
import { FormularComponent } from './formular/formular.component';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DATE_FORMATS} from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { InputTypComponent } from './input-typ/input-typ.component';
import { TextareaTypComponent } from './textarea-typ/textarea-typ.component';
import { SelectTypComponent } from './select-typ/select-typ.component';
import { AutocompleteTypComponent } from './autocomplete-typ/autocomplete-typ.component';
import { DateTypComponent } from './date-typ/date-typ.component';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { QuillModule } from 'ngx-quill';
import { MatRadioModule } from '@angular/material/radio';
import { HlavickaDokumentuComponent } from './hlavicka-dokumentu/hlavicka-dokumentu.component';
import { NadpisBlokSekciaDruhComponent } from './nadpis-blok-sekcia-druh/nadpis-blok-sekcia-druh.component';
import { HeaderPolozkaComponent } from './header-polozka/header-polozka.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MY_DATE_FORMATS } from './my-date-formats';
import {DatePipe, registerLocaleData} from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { StudijneProgramyComponent } from './studijne-programy/studijne-programy.component';
import { StudijnyProgramComponent } from './studijny-program/studijny-program.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { StudijneProgramyZaznamuComponent } from './studijne-programy-zaznamu/studijne-programy-zaznamu.component';
import { StudijneProgramyCopyingDialogComponent } from './studijne-programy-copying-dialog/studijne-programy-copying-dialog.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { ChecklistDialogComponent } from './checklist-dialog/checklist-dialog.component';
import { StupenTypStudiaComponent } from './stupen-typ-studia/stupen-typ-studia.component';
import { PodprogramyCopyingDialogComponent } from './podprogramy-copying-dialog/podprogramy-copying-dialog.component';
import { ZaverecnePraceDialogComponent } from './zaverecne-prace-dialog/zaverecne-prace-dialog.component';
import { ProfiloveAOstatneZabezpecovanePredmetyDialogComponent } from './profilove-a-ostatne-zabezpecovane-predmety-dialog/profilove-a-ostatne-zabezpecovane-predmety-dialog.component';
import {MatTableModule} from '@angular/material/table';
import {MatExpansionModule} from '@angular/material/expansion';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        FormularComponent,
        InputTypComponent,
        TextareaTypComponent,
        SelectTypComponent,
        AutocompleteTypComponent,
        DateTypComponent,
        ProgressSpinnerComponent,
        HlavickaDokumentuComponent,
        NadpisBlokSekciaDruhComponent,
        HeaderPolozkaComponent,
        StudijneProgramyComponent,
        StudijnyProgramComponent,
        StudijneProgramyZaznamuComponent,
        StudijneProgramyCopyingDialogComponent,
        ChecklistDialogComponent,
        StupenTypStudiaComponent,
        PodprogramyCopyingDialogComponent,
        ZaverecnePraceDialogComponent,
        ProfiloveAOstatneZabezpecovanePredmetyDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      AisCommonModule,
      MatCardModule,
      MatInputModule,
      MatIconModule,
      FormsModule,
      MatButtonModule,
      MatSelectModule,
      MatTooltipModule,
      MatDatepickerModule,
      MatNativeDateModule,
      ReactiveFormsModule,
      MatAutocompleteModule,
      MatProgressSpinnerModule,
      MatRadioModule,
      MatDialogModule,
      MatDividerModule,
      MatCheckboxModule,
      MatTableModule,
      MatExpansionModule,
      QuillModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        },
        defaultLanguage: 'sk'
      })
  ],
  providers: [
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'sk-SK'
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_DATE_FORMATS
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
